export default __webpack_public_path__ + "static/media/Letters2_01.382ab387.png";